<script setup lang="ts"></script>

<template>
    <section class="table-layout">
        <slot />
    </section>
</template>
